var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var CTAAnchor = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  text-decoration: none;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  text-decoration: none;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverBg;
});
var templateObject_1;
//# sourceMappingURL=CTAAnchor.js.map